
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Link from 'next/link';
import { GetStaticProps, NextPage } from 'next/types';
import { PAGE } from '../../../consts/PAGES';
import { getVPerfectById } from '../../../utils/getPage';
interface IVPerfectPage {
    page: {
        title: string;
        vPerfect: {
            title1: string;
            title2: string;
            title3: string;
            title4: string;
            description1: string;
            description2: string;
            description3: string;
            description4: string;
            photos2: {
                photo: {
                    sourceUrl: string;
                };
            }[];
            photos3: {
                photo: {
                    sourceUrl: string;
                };
            }[];
        };
        en: {
            title: string;
            vPerfect: {
                title1: string;
                title2: string;
                title3: string;
                title4: string;
                description1: string;
                description2: string;
                description3: string;
                description4: string;
                photos2: {
                    photo: {
                        sourceUrl: string;
                    };
                }[];
                photos3: {
                    photo: {
                        sourceUrl: string;
                    };
                }[];
            };
        };
    };
}
const VPerfectPage: NextPage<IVPerfectPage> = ({ page }) => {
    const { lang } = useTranslation('common');
    return (<>
      <NextSeo languageAlternates={[
            { hrefLang: 'x-default', href: 'https://knsokna.pl/pvc/v-perfect' },
            { hrefLang: 'en', href: 'https://knswindows.com/pvc/v-perfect' },
            { hrefLang: 'pl', href: 'https://knsokna.pl/pvc/v-perfect' },
            { hrefLang: 'de', href: 'https://knsfenster.de/pvc/v-perfect' },
            { hrefLang: 'cs', href: 'https://kns-okna.eu/pvc/v-perfect' },
            { hrefLang: 'it', href: 'https://knsfinestre.it/pvc/v-perfect' },
            { hrefLang: 'fr', href: 'https://knsfenetres.fr/pvc/v-perfect' },
            { hrefLang: 'hu', href: 'https://knsokna.eu/pvc/v-perfect' },
        ]}/>
      <div className="bg-white">
        <div className="w-full bg-black text-white">
          <Image src="/img/v-perfect.jpg" alt="V-Perfect" width="1920" height="729" className="w-full"/>
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page?.vPerfect?.title1
            ? page.vPerfect?.title1
            : page?.en?.vPerfect?.title1}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.vPerfect?.description1
                ? page?.vPerfect?.description1
                : page?.en?.vPerfect?.description1,
        }}/>
          </div>
        </div>

        <div className="w-full bg-white text-black">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.vPerfect?.title2
            ? page.vPerfect?.title2
            : page?.en?.vPerfect?.title2}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.vPerfect?.description2
                ? page.vPerfect?.description2
                : page?.en?.vPerfect?.description2,
        }}/>
            <div className="flex flex-wrap justify-center">
              {page?.vPerfect?.photos2?.map((photo, i) => (<div key={i} className="p-2">
                  <Image src={photo?.photo?.sourceUrl} alt="V-Perfect" width="300" height="300" className="w-96"/>
                </div>))}
            </div>
          </div>
        </div>

        <div className="w-full bg-white text-black">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.vPerfect?.title3
            ? page.vPerfect?.title3
            : page?.en?.vPerfect?.title3}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.vPerfect?.description3
                ? page.vPerfect?.description3
                : page?.en?.vPerfect?.description3,
        }}/>
            <div className="flex flex-wrap justify-center">
              {page?.vPerfect?.photos3?.map((photo, i) => (<div key={i} className="p-2">
                  <Image src={photo?.photo?.sourceUrl} alt="V-Perfect" width="300" height="300" className="w-96"/>
                </div>))}
            </div>
          </div>
        </div>

        <div className="w-full bg-black text-gray-400 text-center">
          <Image src="/img/v-perfect-bg.jpg" alt="V-Perfect" width="1920" height="643" className="w-full"/>
        </div>

        <div className="w-full bg-white text-black">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.vPerfect?.title4
            ? page.vPerfect?.title4
            : page?.en?.vPerfect?.title4}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.vPerfect?.description4
                ? page.vPerfect?.description4
                : page?.en?.vPerfect?.description4,
        }}/>
          </div>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || 'PL';
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const PAGE_ID = PAGE.VPERFECT[LOCALE as keyof typeof PAGE.VPERFECT] || 1;
    const { page } = await getVPerfectById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default VPerfectPage;

    async function __Next_Translate__getStaticProps__196386c50a0__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/v-perfect/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c50a0__ as getStaticProps }
  